import { Paginator } from 'primereact/paginator';


function PrimePaginator(props)  {

  // Define variables
  const first = props.first;
  const totalRecords = props.totalRecords;
  const rows = props.rows;
  const onPageChange = props.onPageChange;


  return (
    <Paginator
      first={first}
      rows={rows}
      totalRecords={totalRecords}
      onPageChange={onPageChange}
    />
  );
}

export default PrimePaginator;